//mobile footer menu

$('.footer-block--menu .footer-block__heading').on('click', function(){
    $(this).siblings().toggleClass('footer-block--menu-open');
    $(this).toggleClass("footer-block--heading-open");
})

//Animate on scroll initiation
$(function() {
    AOS.init(); // Animation AOS library init
});
// Wish list (Dream list) - Inject print button
$(document).on("click",".preheader_links[href='#swym-wishlist']",function(event){
  var changeFlag = true
  if (changeFlag){
    var intervalFn = setInterval(function (){
      if ($('.swym-wishlist-context-menu').length == 1){
        $('.swym-wishlist-context-menu.swym-icon.swym-is-button').click()
        if ( $('#dreamlist_print_btn').length == 0){
          $('.swym-wishlist-detail-header').append('<button onClick="printPageArea(`dreamlist`)" id="dreamlist_print_btn" class="btn swym-wishlist-context-menu-item swym-print swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span><span>Print / Save</span></button>')
          changeFlag = false;
          clearInterval(intervalFn)
          // console.log('interval.. ')
        }
      }
    }, 500);
  }
})
  
  
function printPageArea(area = null){
  if (area == 'dreamlist'){
    $('body').addClass('printarea_dreamlist')
  }else{
    $('body').removeClass('printarea_dreamlist')
  }
  window.print()
}



function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// waitForElm('.strmpr-search-result-filters').then((elm) => {
//   setTimeout(function() { 
//   $('.strmpr-filter-toggle-name-0 label').click();
//   }, 1000);
// });




$(document).ready(function(){
  // on Product page
  // if ($('.js-zoom-enabled').length > 0 || (window.innerWidth < 750 && $('.pt.product__media.enable_zoom_lightbox').length > 0) ){
  //   $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //   $('.js-zoom-enabled').each( function(){
  //     let zoomUrl = $(this).data('zoom');
  //     $(this).zoom({
  //       url: zoomUrl
  //     });
  //   })
  // }
  // $(window).resize(function() {
  //   if ( window.innerWidth < 750 ) {
  //     $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //     $('.enable_zoom_lightbox.js-zoom-enabled').each( function(){
  //       let zoomUrl = $(this).data('zoom');
  //       $(this).zoom({
  //         url: zoomUrl
  //       });
  //     })
  //   }else {
  //     $('.pt.product__media.enable_zoom_lightbox').removeClass('js-zoom-enabled');
  //   }
  // })

  // Product template Okendo review section - Jun 2024
  $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').hide(); // 1. Hide okendo review first
  // 2. Show if the section has slider content. 
  waitForElm('.template-product .okeReviews .oke-reviewCarousel-slider').then((elm) => {
    $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').show();
  });

  $('.preheader_links').on('click', function(){
    console.log('wishlist');
    var existCondition = setInterval(function() {
      if ($('.swym-value').length) {
        console.log("Exists!");
         clearInterval(existCondition);
        
        $('.swym-value').each(function(){
           var thisText = $(this).text();
           $(this).text('');

           var removeNZD = thisText.slice(3, -3);
      
           $(this).empty();
            $(this).text('$'+removeNZD);
           //console.log(removeNZD);
        });
         
       

      }
     }, 600); // check every 100ms
  });

  // Global - Announcement bar slider
  // if ( $(window).width() < 990 ) {
  //   // active Slider
  //   announcementBarMobileSlider()
  // } else {
  //   // destory slider
  //   disableMobileCarousel('#shopify-section-announcement-bar')
  // }
  announcementBarMobileSlider()
});


  $(function() {


    $('body').on('click', '.variant-wrapper', function(){
      $('.variant-picker').toggle();
      $('.size-option-variant .ico').toggle();
      $('#size-selector').addClass('hidden')
      $('#btn-product-size').removeClass('btn-icon')
    });

    $('body').on('click', '.product-size-selector-wrapper', function(){
      console.log('product-size-selector-wrapper');
      $('.variant-picker').hide(); 
      $('.size-option-variant .ico').hide();
    });

   

    $('body').on('click', '.variant-picker li ', function(){
      console.log('clicked');
      let getVID = $(this).data('vid');
      window.history.replaceState(null, null, `?variant=${getVID}`);
      location.reload();
    });

    if (window.location.href.indexOf("variant") > -1) {
      getVarName = $('.ul-selected').text();
      $('.variant-name').text(getVarName);
    } else {
      getVarName = $('.variant-picker li').first().text();
      $('.variant-name').text(getVarName);
    }
  });

// new announcement bar slider
// $(window).resize(function() {
//   if ( $(window).width() < 990 ) {
//     // active Slider
//     announcementBarMobileSlider()
//   } else {
//     // destory slider
//     disableMobileCarousel('#shopify-section-announcement-bar')
//   }
// })

function announcementBarMobileSlider(){
  let x = '#shopify-section-announcement-bar';
  $(x).addClass('owl-carousel').addClass('owl-theme');
  $(x).owlCarousel({
    loop: true,
    dots: false,
    autoWidth: false,
    autoHeight: false,
    items:1,
    nav: false,
    autoplay:true,
    // autoplayTimeout:3000,
    autoplayHoverPause:true,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp', 
    
    // smartSpeed:3000
  })
  // .trigger('refresh.owl.carousel');
}

function disableMobileCarousel(x){
  $(x).trigger('destroy.owl.carousel');
  $(x).removeClass('owl-carousel');
}

// Check if the device is a mobile device
function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

// Function to add slick slider to elements with class .js-mobile-slider
function addSlickSliderToMobile() {
    if (isMobileDevice()) {
        $('.js-mobile-slider').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 2.5,
                slidesToScroll: 3,
                dots: true,
                centerMode: true,
                adaptiveHeight: true
            });
        });
        $('.js-mobile-slider-none-overlap').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                dots: true,
            });
        });
        $('.js-mobile-slider-single-item').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                
                dots: true,
            });
        });
        $('.js-mobile-slider-one-per').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 1,
                slidesToScroll: 1,                
                dots: true,
            });
        });
    }
}

// Execute the function when the DOM is ready
$(document).ready(function() {
    addSlickSliderToMobile();
});



$(document).ready(function() {
    $('.mega-menu').mouseenter(function() {
        $(this).attr('open', '');
        $('.slideshow__controls').hide();
    });

    $('.mega-menu').mouseleave(function() {
        $(this).removeAttr('open');
        $('.slideshow__controls').show();
    });
});

// window.addEventListener('scroll', function() {
//   var body = document.body;
//   var scrollPosition = window.scrollY;
//   var scrollThreshold = window.innerWidth <= 768 ? 50 : 1; // Adjust threshold for mobile devices
  
//   if (scrollPosition > scrollThreshold) {
//     body.classList.add('fixed-header');
//   } else {
//     body.classList.remove('fixed-header');
//   }
// });

function paymentsWidget(e){
  let isActive = $(e).hasClass('active') ? true : false;

  if (isActive){
    $(e).removeClass('active') // hide 
  }else {
    $(e).addClass('active')// Show
  }
}

function customDecreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) - 1

  let minQty = 1
  
  // Check maximum value and block if it's over the max value
  if (currentQty <= minQty){
    // console.log('1 is the minimum !!')
    return false;
  }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function customIncreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) + 1

  let maxQty = selectBox.find('option').length
  
  // Check maximum value and block if it's over the max value
  if (currentQty >= maxQty){
    // console.log('max value reached !!!')
    return false;
  }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function updateRebuyWidget(widgetID, pID, updatedQty){
  console.log('updateRebuyWidget ->',widgetID, pID, updatedQty)

  let widgetList = Rebuy.widgets

  widgetList.forEach((e)=>{
    if (e.id == widgetID){
      let products = e.data.products;
      products.forEach((p)=>{
        if (p.id == pID){
          p.quantity = updatedQty
          console.log('!!!!!!', p.id, p.quantity)
        }
      });
    }
  })
}